import { createSlice } from '@reduxjs/toolkit';
import { iInitState, iPromotionListing } from '~/app/models';

interface iState extends iInitState {
  data: iPromotionListing;
  dataDetails: any;
  message: string;
  urlData: {
    pageSize: number;
    currentPage: number;
  };
  queryString: string;
  isDESC: boolean;
  keySearch: string;
  controller: any;
  couponCode: any;
}

const initialState: iState = {
  status: '',
  controller: null,
  data: { items: [], search_criteria: {}, total_count: 0 } as iPromotionListing,
  urlData: { pageSize: 10, currentPage: 1 },
  dataDetails: {},
  message: '',
  isDESC: false,
  keySearch: 'rule_id',
  queryString: '',
  couponCode: {},
};

const promotionSlice = createSlice({
  name: 'PROMOTION LIST',
  initialState,
  reducers: {
    resetData: () => ({ ...initialState }),
    setQueryString: (state, action) => ({ ...state, queryString: action.payload }),

    setUrlData: (state, action) => ({ ...state, urlData: action.payload }),
    setIsDESC: (state, action) => ({ ...state, isDESC: action.payload }),
    setKeySearch: (state, action) => ({ ...state, keySearch: action.payload }),

    changeController: (state, action) => ({ ...state, controller: action.payload }),

    // Asynchronous Actions
    getDataFulfilled: (state, action) => ({ ...state, data: action.payload, status: 'fulfilled' }),
    getDataRejected: (state, action) => ({ ...state, status: 'rejected', message: action.payload }),
    getDataPending: (state) => ({ ...state, status: 'pending' }),
    resetQueryString: (state) => ({ ...state, queryString: '' }),
    getCouponCode: (state, action) => ({ ...state, couponCode: action.payload }),
  },
});

export const { ...rest } = promotionSlice.actions;
const promotionReducer = promotionSlice.reducer;

export default promotionReducer;
